module.exports = __webpack_public_path__ + "img/00015.ff9ca0bc.webp";